import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { MapGeoJsonResponse } from '@tq/ui-components/dist/components/map';

import { API_QUERY_KEYS } from 'api';
import { getMapPolygon } from '../methods';
import { QueryDefaults } from '../../constants';

export const useMapPolygon = (consultationId: number): UseQueryResult<MapGeoJsonResponse> =>
  useQuery(
    [API_QUERY_KEYS.getMap, consultationId],
    () => getMapPolygon(consultationId),
    QueryDefaults
  );
